import { type FrontendRoutes, generateFrontendRoutes } from '@cosuno/routes';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useCurrentUser } from './useCurrentUser';

export const useUserRoutes = (props?: { withoutWorkspace: boolean }): FrontendRoutes => {
  const { workspaceId: workspaceIdFromParams } = useParams<{ workspaceId?: string }>();
  const user = useCurrentUser();

  // validate workspaceId
  const workspaceId = useMemo(() => {
    // do we have a current user to validate the workspaceId?
    if (!user) {
      return workspaceIdFromParams;
    }
    // first check if the current workspaceId from params is valid and return if it is
    if (workspaceIdFromParams && user.workspaces.find(({ id }) => id === workspaceIdFromParams)) {
      return workspaceIdFromParams;
    }
    return user.workspaces.find(({ isCurrent }) => isCurrent)?.id;
  }, [user, workspaceIdFromParams]);

  return useMemo(
    () =>
      generateFrontendRoutes({
        workspaceId,
        withoutWorkspace: props?.withoutWorkspace,
      }),
    [workspaceId, props?.withoutWorkspace],
  );
};
